<template>
  <div id="app">

    <Navbar v-if="$route.path.indexOf('zaplecze') === -1"/>
    <NavbarZaplecze v-else/>

    <router-view/>

  </div>
</template>

<script>
import Navbar from './components/Navbar'
import NavbarZaplecze from './components/NavbarZaplecze'

export default {
  name: 'App',
  mixins: [app],
  data () {
    return {
    }
  },
  components: {
    Navbar, NavbarZaplecze
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue